import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'

export interface MaterialsRow {
    materialTypeName: string
    materialCode: string
    materialName: string
    salePrice: string
    status: string
    updatedBy: string
    updatedAt: string
}

export interface MaterialsReport {
    title: string
    statusFilter: string
    rows: MaterialsRow[]
    t: any
}

export async function exportMaterialsToExcel(report: MaterialsReport) {
    // 1) สร้าง workbook + worksheet
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(report.title, {
        pageSetup: { orientation: 'portrait' }
    })
    ws.properties.defaultRowHeight = 20

    // 2) กำหนดความกว้างคอลัมน์ แต่ยังไม่กำหนด header เพราะเราจะสร้างเอง
    ws.columns = [
        { width: 6 },
        { width: 30 },
        { width: 20 },
        { width: 30 },
        { width: 20 },
        { width: 14 },
        { width: 30 },
    ]

    // 3) ExcelJS จะสร้าง header row อัตโนมัติให้ 1 แถว
    //    เราจึงลบแถวแรกนั้นทิ้งก่อน
    ws.spliceRows(1, 1)

    let rowIndex = 1

    // 4) แทรก Title (merge A1:D1)
    ws.mergeCells(rowIndex, 1, rowIndex, 7)
    const titleCell = ws.getCell(rowIndex, 1)
    titleCell.value = report.title
    titleCell.font = { size: 16, bold: true }
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' }
    rowIndex += 2

    // 5) แทรก Status Filter (merge A3:D3)
    ws.mergeCells(rowIndex, 1, rowIndex, 7)
    const statusCell = ws.getCell(rowIndex, 1)
    statusCell.value = report.statusFilter
    statusCell.font = { size: 12 }
    statusCell.alignment = { horizontal: 'left', vertical: 'middle' }
    rowIndex += 2

    // 6) สร้าง Header Row ใหม่ ในตำแหน่ง rowIndex
    const headers = [
        '#',
        report.t('MATERIAL.TABLE.CELLS_MED.MATERIAL_TYPE'),
        report.t('MATERIAL.TABLE.CELLS_MED.MATERIAL_CODE'),
        report.t('MATERIAL.TABLE.CELLS_MED.MATERIAL_NAME'),
        report.t('MATERIAL.TABLE.CELLS_MED.PRICE'),
        report.t('MATERIAL.TABLE.CELLS_MED.STATUS'),
        report.t('MATERIAL.TABLE.CELLS_MED.UPDATED_BY'),
    ]
    const headerRow = ws.getRow(rowIndex)
    headerRow.values = headers
    headerRow.height = 24
    headerRow.font = { bold: true }
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
    headerRow.eachCell(cell => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }
        }
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    })
    rowIndex++
    if (!report.rows || report.rows.length === 0) {
        const noDataRow = ws.addRow([report.t('REPORT.TITLE.NO_DATA')])
        ws.mergeCells(noDataRow.number, 1, noDataRow.number, ws.columns.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
        const buf = await wb.xlsx.writeBuffer()
        saveAs(
            new Blob([buf]),
            `${report.title}_${moment().format('YYYYMMDD')}.xlsx`
        )
        return
    }
    // 7) เติมข้อมูลแต่ละแถว
    report.rows.forEach((r, i) => {
        const excelRow = ws.getRow(rowIndex + i)
        excelRow.values = [
            i + 1,
            r.materialTypeName,
            r.materialCode,
            r.materialName,
            r.salePrice,
            r.status,
            `${r.updatedBy} ${r.updatedAt}`
        ]
        excelRow.height = 20

        excelRow.eachCell((cell, col) => {
            // border รอบ cell
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            // จัด alignment / number format ตามคอลัมน์
            switch (col) {
                case 2:
                case 3:
                case 4:
                    cell.alignment = { horizontal: 'left', vertical: 'middle' }
                    break
                case 5:
                    cell.numFmt = '#,##0.00'
                    cell.alignment = { horizontal: 'right', vertical: 'middle' }
                    break
                default:
                    cell.alignment = { horizontal: 'center', vertical: 'middle' }
            }
        })
    })

    // 8) สร้างไฟล์และดาวน์โหลด
    const buf = await wb.xlsx.writeBuffer()
    saveAs(
        new Blob([buf]),
        `${report.title}_${moment().format('YYYYMMDD')}.xlsx`
    )
}
